import { FormattedMessage } from 'react-intl';

import { IconReturn } from '@xing-com/icons';

import { useSearchContext } from '../../context';
import type { SearchParamsType } from '../../types';
import { AppliedFiltersTagContainer, ResetButton } from '../shared-styles';

type Props = {
  appliedFilters: SearchParamsType;
  children?: React.ReactNode;
};

export const AppliedFilters: React.FC<Props> = ({
  appliedFilters,
  children,
}) => {
  const { resetFilters } = useSearchContext();

  const areFiltersEmpty =
    appliedFilters &&
    Object.keys(appliedFilters)
      .filter((key) => key !== 'sort')
      .filter((key) => key !== 'keywords').length === 0;

  if (areFiltersEmpty) {
    return null;
  }

  return (
    <AppliedFiltersTagContainer data-testid="applied-filters">
      {children}
      <ResetButton
        data-testid="applied-filters-reset-button"
        icon={IconReturn}
        onClick={resetFilters}
        variant="tertiary"
        size="small"
      >
        <FormattedMessage id="SE_FILTERS_RESET_ACTION" />
      </ResetButton>
    </AppliedFiltersTagContainer>
  );
};
